module.exports = __webpack_public_path__ + "img/simulados-dos-cursos.dfb5c0e9.png";